import PropTypes from "prop-types";
import MuiSearchIcon from "@mui/icons-material/Search";
import GroupIcon from "@mui/icons-material/Group";

export function SearchIcon(props) {
  return <MuiSearchIcon {...props} />;
}

SearchIcon.propTypes = {
  color: PropTypes.string,
};

export function PersonSearchIcon(props) {
  const fontSize = props.fontSize || 26;
  return (
    <div
      style={{
        position: "relative",
        top: -3,
        width: fontSize + 8,
        height: fontSize - 3,
      }}>
      <div style={{ position: "absolute" }}>
        <GroupIcon style={{ fontSize: fontSize, top: 2 }} {...props} />
      </div>
      <div style={{ position: "absolute", left: 10, top: -5 }}>
        <SearchIcon style={{ fontSize: fontSize }} {...props} />
      </div>
    </div>
  );
}

PersonSearchIcon.propTypes = {
  fontSize: PropTypes.number,
};
